/**
 * Legal page shell (V1 auth-profiles-gdpr — S-27 About/legal surfaces).
 * Serious tone throughout (copy-tone §1.4 applies to legal surfaces).
 * v3: intentionally unthemed — typographic readability only (legal.css).
 */
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { IconBrokenHeart } from "../../design/index.js";
import "./legal.css";

export function LegalPage({ title, children }: { title: string; children: ReactNode }) {
  return (
    <div className="legal">
      <nav className="legal__nav">
        <Link to="/" className="legal__brand">
          <IconBrokenHeart width={20} height={20} style={{ color: "var(--accent)" }} />
          humble
        </Link>
        <span className="legal__links">
          <Link to="/legal/terms">Terms</Link>
          <Link to="/legal/privacy">Privacy</Link>
          <Link to="/safety">Safety</Link>
        </span>
      </nav>
      <div className="legal__body">
        <h1>{title}</h1>
        {children}
      </div>
      <footer className="legal__footer text-faint">
        Humble · humble.ekaii.fr · Questions:{" "}
        <a href="mailto:support@humble.ekaii.fr">support@humble.ekaii.fr</a>
      </footer>
    </div>
  );
}
